/* One playback owner for native product galleries. Thumbnails remain still images. */
(() => {
  if (window.ehqGalleryVideo) return;
  window.ehqGalleryVideo = true;
  const videos = new Set(), visible = new WeakMap(), pending = new WeakSet();
  const trackSelector = '[data-gallery-track],[data-g-track],.gal-track,.gal__track';
  let scheduled = false;
  function canPlay(video) {
    if (document.hidden || !video.isConnected || video.closest('[hidden]') || !visible.get(video)) return false;
    const track = video.closest(trackSelector);
    if (!track) return false;
    const v = video.getBoundingClientRect(), t = track.getBoundingClientRect();
    const overlap = Math.max(0, Math.min(v.right, t.right) - Math.max(v.left, t.left));
    return v.width > 0 && overlap >= Math.min(v.width, t.width) * 0.6;
  }
  function update() {
    scheduled = false;
    videos.forEach(video => {
      if (!video.isConnected) { observer.unobserve(video); videos.delete(video); return; }
      if (!canPlay(video)) { video.pause(); return; }
      if (!video.paused || pending.has(video)) return;
      pending.add(video);
      const attempt = video.play();
      Promise.resolve(attempt).catch(() => {}).finally(() => {
        pending.delete(video);
        if (!canPlay(video)) video.pause();
      });
    });
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => visible.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.25));
    update();
  }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
  function discover() {
    document.querySelectorAll('[data-gallery] video').forEach(video => {
      if (videos.has(video) || !video.closest(trackSelector)) return;
      videos.add(video);
      video.controls = false;
      video.removeAttribute('controls');
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.autoplay = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.pause();
      video.addEventListener('play', () => { if (!canPlay(video)) video.pause(); });
      video.addEventListener('loadeddata', schedule);
      observer.observe(video);
    });
    schedule();
  }
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  document.addEventListener('visibilitychange', update);
  document.addEventListener('pointerup', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  new MutationObserver(discover).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  discover();
})();
